module.exports = __webpack_public_path__ + "img/VillaLoreto_Spa.a35bc628.jpg";